import './globals'
import { loadPolyfills } from './polyfill'

loadPolyfills()
  .then(() => import('./Root'))
  .then(({ loadApp }) => loadApp())



// WEBPACK FOOTER //
// ./src/index.js